import { render, staticRenderFns } from "./TicketsTableEnAttente.vue?vue&type=template&id=20e1b779"
import script from "./TicketsTableEnAttente.vue?vue&type=script&lang=js"
export * from "./TicketsTableEnAttente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports